import joanchor from './anchor.vue'
import jobold from './bold.vue'
import jodispquote from './dispquote.vue'
import joextlink from '../../../../commonComponents/extlink'
import jouri from './uri.vue'
import joinlinenote from './inlinenote.vue'
import joitalic from './italic.vue'
import jop from './p.vue'
import josec from './sec.vue'
import josectitle from './sectitle.vue'
import josub from './sub.vue'
import josup from './sup.vue'
import jotext from './text.vue'
import jovocab from './vocab.vue'
import joxref from './xref.vue'
import jostrike from './strike.vue'
import jooverline from './overline.vue'
import jounderline from './underline.vue'
import joinlineformula from '../formula/inlineformula.vue'
import joinlinegraphic from '../fig/inlinegraphic.vue'
import joblockXref from '../../../../commonComponents/blockxref.vue'
import jostyleText from '../../../../commonComponents/styleText.vue'

export default {
  install (Vue) {
    Vue.component('joanchor', joanchor)
    Vue.component('jobold', jobold)
    Vue.component('jodispquote', jodispquote)
    Vue.component('joextlink', joextlink)
    Vue.component('jouri', jouri)
    Vue.component('joinlinenote', joinlinenote)
    Vue.component('joitalic', joitalic)
    Vue.component('jop', jop)
    Vue.component('josec', josec)
    Vue.component('josectitle', josectitle)
    Vue.component('josub', josub)
    Vue.component('josup', josup)
    Vue.component('jotext', jotext)
    Vue.component('jovocab', jovocab)
    Vue.component('joxref', joxref)
    Vue.component('jostrike', jostrike)
    Vue.component('jooverline', jooverline)
    Vue.component('jounderline', jounderline)
    Vue.component('joinlineformula', joinlineformula)
    Vue.component('joinlinegraphic', joinlinegraphic)
    Vue.component('joblockXref', joblockXref)
    Vue.component('jostyleText', jostyleText)
  }
}



// WEBPACK FOOTER //
// ./src/components/maincontent/body/common/index.js